/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganization200Response
 */
export interface CreateOrganization200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganization200Response
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganization200Response
     */
    organizationId: string;
}

/**
 * Check if a given object implements the CreateOrganization200Response interface.
 */
export function instanceOfCreateOrganization200Response(value: object): value is CreateOrganization200Response {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function CreateOrganization200ResponseFromJSON(json: any): CreateOrganization200Response {
    return CreateOrganization200ResponseFromJSONTyped(json, false);
}

export function CreateOrganization200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganization200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'organizationId': json['organizationId'],
    };
}

export function CreateOrganization200ResponseToJSON(json: any): CreateOrganization200Response {
    return CreateOrganization200ResponseToJSONTyped(json, false);
}

export function CreateOrganization200ResponseToJSONTyped(value?: CreateOrganization200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'organizationId': value['organizationId'],
    };
}

